import { ICON__check, ICON__x_mark_solid } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { UI_PRIMITIVE__text_area } from '@/components/ui/UI_PRIMITIVE__text_area';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_field_for_generation_layout } from '@/state/ui/image/LOCAL__ui_set_field_for_generation_layout';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { FIELD__list_token } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_token';
import { FIELD__token } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD__token';
import { useLayoutEffect, useRef, useState } from 'react';

interface PROPS {
  field: FIELD__token;
  field_parent: FIELD__list_token;
}

export function G_UI_FIELD__token_list_item_text_area({ field, field_parent }: PROPS) {
  const dispatch = use_dispatch();

  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);
  /*
   *
   */
  const [input_value, set_input_value] = useState(field.word_english.get_value());
  const ref_textarea = useRef<HTMLTextAreaElement | null>(null);
  const ref__is_loading = useRef(false);

  /*
   *
   */
  useLayoutEffect(() => {
    const textarea_element = ref_textarea.current;
    if (!textarea_element) return;

    const textLength = textarea_element.value.length;
    textarea_element.setSelectionRange(textLength, textLength);
  }, []);

  /*
   * EVENTS
   */

  function onChange(e: React.ChangeEvent<HTMLTextAreaElement>) {
    let value_string = e.target.value.toLowerCase();

    set_input_value(value_string);
  }

  async function on_click_buttons_save() {
    if (ref__is_loading.current) return;

    if (field.word_english.get_value() == input_value.trim_lowercase(false)) return; //nothing changed

    /*
     *
     */

    let field_parent_new = field_parent.clone();

    let need_delete_token = input_value.trim_lowercase(false).is_blank();

    /*
     * EDGE CASE
     */
    if (need_delete_token) {
      field_parent_new.item_remove(field);
    }

    /*
     * BODY
     */
    let tokens_string = FIELD__token.from_string_get_words(input_value);

    let is_positive = field.is_positive.get_value();

    for (let i = 0; i < tokens_string.length; i++) {
      let token_string = tokens_string[i];

      let field_token: FIELD__token = FIELD__token.CREATE_STUB();

      if (i == 0) {
        //get existing field for first word
        field_token = field_parent_new.items.find_or_assert(item => item.meta.field_id == field.meta.field_id);
      } else {
        //try find by word
        field_token = field_parent_new.items.find_or_default(item => item.word_english.get_value() == token_string, field_token);
      }

      if (field_token.is_stub()) {
        field_token = field_parent_new.create_item_new(false);

        let index_to_insert_token = is_positive ? field_parent_new.get_index_to_insert_token_positive() : field_parent_new.get_index_to_insert_token_negative();

        field_parent_new.items.insert_at(index_to_insert_token, field_token);
      }

      FIELD__token.fill_field_from_token_string(token_string, field_token);
    }

    /*
     * UPDATE
     */

    ref__is_loading.current = true;

    field_parent_new.field_name_and_path__fill_for_children();

    on_click_buttons_cancel();

    await UTILS__graph_data.update_field(generation_current.tool.graph, field_parent_new);

    ref__is_loading.current = false;
  }

  function on_click_buttons_cancel() {
    dispatch(LOCAL__ui_set_field_for_generation_layout({ key: 'g_grid2d__token_edit', field: FIELD__token.CREATE_STUB() }));
  }

  /*
   *
   */

  function is_disabled() {
    return g_general__ui_disabled || ref__is_loading.current;
  }

  /*
   *
   */
  return (
    <div className="size-full p-0.5 flex flex-row">
      <div className="flex-1 h-full">
        <UI_PRIMITIVE__text_area
          ref={ref_textarea}
          autoFocus
          {...{ onChange }}
          lineCount={2}
          placeholder="Enter token"
          className="p-1 border-none rounded-sm text-xs text-component-item-foreground"
          value={input_value}
        />
      </div>
      <div className="flex flex-col flex-shrink-0 min-w-0 w-6 h-full ">
        <UI_PRIMITIVE__button_with_icon_animated
          variant="no-border-on-component"
          onClick={on_click_buttons_save}
          disabled={is_disabled()}
          size="full-5"
          iconClassNameBase="text-component-item-foreground size-3"
          iconClassNameHovered="!text-bar-foreground"
          Icon={ICON__check}
        />

        <UI_PRIMITIVE__button_with_icon_animated
          variant="no-border-on-component"
          onClick={on_click_buttons_cancel}
          disabled={is_disabled()}
          size="full-5"
          iconClassNameBase="text-component-item-foreground size-3"
          iconClassNameHovered="!text-bar-foreground"
          Icon={ICON__x_mark_solid}
        />
      </div>
    </div>
  );
}
